import { z } from "zod";

export const messageAttachmentSchema = z.object({
  file_name: z.string(),
  type: z.enum(["image"]),
  caption: z.string(),
});
